import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import React, { useEffect, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

export default function AcceptShiftHeader({ step = 0, value = 0, setValue = () => { }, handleTabChange, acceptLength, swapsLength, otSwapsLength, overtimeSwapsLength, posLength }) {
  const [searchParams] = useSearchParams();
  const routeStep = searchParams.get('step');
  const { pages } = useContext(AuthContext);

  useEffect(() => {
    if (routeStep) {
      setValue(routeStep);
    }
  }, [routeStep, setValue]);

  return (
    <Paper elevation={0}>
      <BottomNavigation
        sx={{
          overflow: "auto",
        }}
        className='flex-wrap justify-content-start'
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          handleTabChange(newValue);
        }}
      >
        <BottomNavigationAction
          id="firstSelected"
          sx={{
            flex: "0 0 auto",
            padding: "0px",
            height: '0px !important',
            color: "#333333",
            fontSize: "14px !important",
            backgroundColor: '#f3f3f3',
            padding: '18px 30px !important',
            borderRadius: '40px',
            "& .MuiBottomNavigationAction-label": {
              whiteSpace: "nowrap !important",
              fontWeight: "500",
              fontSize: "14px !important",
            },
            ".Mui-selected&": {
              color: "#fff",
              fontSize: "14px !important",
              backgroundColor: 'rgba(191, 29, 45, 0.8)',
              padding: '18px 30px !important',
              borderRadius: '40px'
            },
          }}
          label={`Accept Shifts (${acceptLength})`}
          className={'mx-1 p-0'}
          component={step === 'preAccept' ? Link : undefined}
          to={'/firehouse/accept-shifts'}
        />
        <BottomNavigationAction
          sx={{
            flex: "0 0 auto",
            padding: "0px",
            height: '0px !important',
            color: "#333333",
            fontSize: "14px !important",
            backgroundColor: '#f3f3f3',
            padding: '18px 30px !important',
            borderRadius: '40px',
            "& .MuiBottomNavigationAction-label": {
              whiteSpace: "nowrap !important",
              fontWeight: "500",
              fontSize: "14px !important",
            },
            ".Mui-selected&": {
              color: "#fff",
              fontSize: "14px !important",
              backgroundColor: 'rgba(191, 29, 45, 0.8)',
              padding: '18px 30px !important',
              borderRadius: '40px'
            },
          }}
          label={`Accept Swaps (${swapsLength})`}
          className={'mx-1 p-0'}
          component={step === 'preAccept' ? Link : undefined}
          to={'/firehouse/accept-shifts?step=1'}
        />
        {pages.includes('V3_OT_SWAPS_FEATURE') &&
          <BottomNavigationAction
            sx={{
              flex: "0 0 auto",
              padding: "0px",
              height: '0px !important',
              color: "#333333",
              fontSize: "14px !important",
              backgroundColor: '#f3f3f3',
              padding: '18px 30px !important',
              borderRadius: '40px',
              "& .MuiBottomNavigationAction-label": {
                whiteSpace: "nowrap !important",
                fontWeight: "500",
                fontSize: "14px !important",
              },
              ".Mui-selected&": {
                color: "#fff",
                fontSize: "14px !important",
                backgroundColor: 'rgba(191, 29, 45, 0.8)',
                padding: '18px 30px !important',
                borderRadius: '40px'
              },
            }}
            label={`Accept Overtime Swaps (${overtimeSwapsLength})`}
            className={'mx-1 p-0'}
            component={step === 'preAccept' ? Link : undefined}
            to={'/firehouse/accept-shifts?step=2'}
          />
        }
        {pages.includes('V3_POSITION_ASSIGNMENT_FILLABLE') &&
          <BottomNavigationAction
            sx={{
              flex: "0 0 auto",
              padding: "0px",
              height: '0px !important',
              color: "#333333",
              fontSize: "14px !important",
              backgroundColor: '#f3f3f3',
              padding: '18px 30px !important',
              borderRadius: '40px',
              "& .MuiBottomNavigationAction-label": {
                whiteSpace: "nowrap !important",
                fontWeight: "500",
                fontSize: "14px !important",
              },
              ".Mui-selected&": {
                color: "#fff",
                fontSize: "14px !important",
                backgroundColor: 'rgba(191, 29, 45, 0.8)',
                padding: '18px 30px !important',
                borderRadius: '40px'
              },
            }}
            label={`Accept Position Assigment (${posLength})`}
            className={'mx-1 p-0'}
            component={step === 'preAccept' ? Link : undefined}
            to={'/firehouse/accept-shifts?step=3'}
          />
           }
      </BottomNavigation>
    </Paper>
  );
}
